import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Container } from '@comparethemarketau/manor-grid';

const useStyles = createUseStyles((theme) => ({
    fullWidth: {
        maxWidth: 'unset'
    }
}));

const ContainerWrapper = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { children, padding, className, fullWidth } = props;

    return (
        <Container
            padding={padding}
            className={classNames(className, fullWidth && classes.fullWidth)}
        >
            {children}
        </Container>
    );
};

ContainerWrapper.propTypes = {
    children: PropTypes.node,
    padding: PropTypes.array,
    className: PropTypes.string,
    /**
     * there is min-width=120rem in manor-container
     */
    fullWidth: PropTypes.bool
};

export { ContainerWrapper };
